import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=0e22ce86&"
import script from "./Outbox.vue?vue&type=script&lang=js&"
export * from "./Outbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports